/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'welcome';
const componentName = 'welcome-system-settings';
const prefix = `${moduleName}.${componentName}`;

export const dnsResolverLabel = `${prefix}.dnsResolverLabel`;
export const dnsSearchDomainLabel = `${prefix}.dnsSearchDomainLabel`;
export const dnsSearchDomainFieldPlaceholder = `${prefix}.dnsSearchDomainFieldPlaceholder`;
export const myAccountSettingsLabel = `${prefix}.myAccountSettingsLabel`;
export const enableConfigurationWarningsChecksLabel = `${prefix}.enableConfigurationWarningsChecksLabel`;

export const ENGLISH = {
    [dnsResolverLabel]: 'DNS Resolver(s)',
    [dnsSearchDomainLabel]: 'DNS Search Domain',
    [dnsSearchDomainFieldPlaceholder]: 'Enter Domain (ex abc.com)',
    [myAccountSettingsLabel]: 'My Account Settings',
    [enableConfigurationWarningsChecksLabel]: 'Enable Configuration Warnings Checks',
};
